module.exports = __webpack_public_path__ + "media/images/icons/hat-icon-295040fb9dfd1a020979c3ca19b06547.svg";